import { Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FabricanteService } from 'src/app/services/fabricante.service';
import { Fabricante } from 'src/app/models/fabricante.model';
import { GLOBAL } from '../../../services/global';
import { FollowService } from 'src/app/services/follow.service';
import { MetricaService } from 'src/app/services/metrica.service';

interface Fotos {
  image: string;
  thumbImage: string;
  title: string;
}

@Component({
  selector: 'app-pagina-fabricante',
  templateUrl: './pagina-fabricante.component.html',
  styleUrls: ['./pagina-fabricante.component.css']
})
export class PaginaFabricanteComponent implements OnInit {
  @ViewChild('imgQR', { static: true }) imgQR: ElementRef;

  arrayBotones = [];
  url = "";
  secciones = [];
  closeResult: string;
  nuevaSeccion: any;
  selectedFile: File = null;
  imageSrc: any;
  filesToUpload: any;
  file: any;
  textImg: any;
  textPrecio: string;
  urlCarta: string;
  qrOk: boolean = false;
  tempGuid: string;
  arrayCarta: any;
  cartaOk: boolean = false;
  tempSeccion: any;
  admin: boolean;
  visibilidadSecciones: Array<any> = [];
  follows: string;
  follow: boolean;
  userLogin: any;
  resultInsertFollow: any;
  urlContactoWhatsapp: string = "";
  pos: any = null;
  pantallaCarga: boolean = false;
  diaSemanaHoy: any = 0;
  carrito: any = null;
  diasSemana = [
    'lunes',
    'martes',
    'miercoles',
    "jueves",
    "viernes",
    "sabado",
    "domingo"
  ];

  @Input() fabricante: any;
  @Output() productoSeleccionado = new EventEmitter<string>();
  @Output() carritoActualizado = new EventEmitter<boolean>();

  constructor(
    private route: ActivatedRoute,
    private fService: FabricanteService,
    private router: Router,
    private filService: FollowService,
    private mService: MetricaService
    /* private modalService: NgbModal,
    private pService: PlatosService */
  ) {
  }

  ngOnInit() {
    this.userLogin = JSON.parse(localStorage.getItem("user"));
    this.carrito = JSON.parse(localStorage.getItem("carrito"));
    this.url = GLOBAL.url;
    this.admin = false;
    this.route.params.subscribe(result => {
      // this.fabricante.id = result.id;
      // this.arrayBotones = GLOBAL.arrayBotonesFabri(result.id);
      this.fabricante.slug = result.slug;
      this.arrayBotones = GLOBAL.arrayBotonesFabri(result.slug);

    });

    this.formatearDatosFabricante();

    const hoy = new Date();
      this.diaSemanaHoy = hoy.getDay() - 1;

      if (this.diaSemanaHoy < 0) {
        this.diaSemanaHoy = 6;
      }
  }

  formatearDatosFabricante(){
  
    this.generarImagenesSecciones();
    this.generarArrayVisibilidad();

    this.fabricante.horario_envio = [];
    this.fabricante.horario_envio_despues_limite = [];
  }

  getFraseHorarioEnvio(){

    let diaSemana = new Date().getDay();
    for(let mensaje of this.fabricante.mensajes_entrega) {
      if(mensaje.dia_semana == diaSemana) {
        if(mensaje.tipo == this.fabricante.responsable_envio_municipio) {
          if(this.esAntesDeHoraLimite()) {
            return mensaje.mensaje_antes_limite;
          }else{
            return mensaje.mensaje_despues_limite;
          }
        }
      }
    }
  }

  esAntesDeHoraLimite(): boolean {
    if (this.fabricante.hora_limite_recogida == null) {
      return false; // Si no hay hora límite, retornar false por defecto
    }
  
    const ahora = new Date();
    const horaLimite = this.fabricante.hora_limite_recogida;
    
    // Parsear la hora límite (formato "HH:mm")
    const [horaLimiteStr, minutoLimiteStr] = horaLimite.split(':');
    const horaLimiteNum = parseInt(horaLimiteStr, 10);
    const minutoLimiteNum = parseInt(minutoLimiteStr || '0', 10);
    
    // Crear fecha de referencia con la hora límite del día de hoy
    const horaReferencia = new Date();
    horaReferencia.setHours(horaLimiteNum, minutoLimiteNum, 0, 0);
    
    // Comparar timestamps
    return ahora.getTime() <= horaReferencia.getTime();
  }

  convertirSaltosDeLinea(texto) {
    return texto.replace(/\r\n|\r|\n/g, '<br>');
  }

  generarArrayVisibilidad() {
    for (let seccion of this.fabricante.secciones) {
      this.visibilidadSecciones[(<any>seccion).id] = false;
    }
  }

  generarImagenesSecciones = () => {
    for (let i = 0; i < (<any>this.fabricante).secciones.length; i++) {
      let fotosSeccion = [];
      for (let z = 0; z < (<any>this.fabricante).secciones[i].productos_secciones.length; z++) {

        let cantidadCarrito = 0;
        let producto=(<any>this.fabricante).secciones[i].productos_secciones[z].producto;

        if(producto.precios.length>0){
          cantidadCarrito = this.getCantidadCarrito(producto.id, producto.precios[0].id);
        }

        fotosSeccion.push({
          thumbImage: GLOBAL.url + (<any>this.fabricante).secciones[i].productos_secciones[z].producto.img
          , descripcion: producto.descripcion
          , alergenos: producto.alergenos
          , nombreProducto: producto.nombre
          , precioProducto: producto.precios.length>0?{
            precio:producto.precios[0].precio,
            precioId:producto.precios[0].id,
            unidadVenta:producto.precios[0].unidad_venta
          }:null
          , hastagProductoMarca: producto.hashtag
          , guidProducto: producto.guid
          , idProducto: producto.id
          , slugProducto: producto.slug
          , enVenta: producto.en_venta
          , cantidad: cantidadCarrito
          , estadoVenta: producto.estado
        });
      }
      (<any>this.fabricante).secciones[i].fotoProductos = fotosSeccion;
    }
  }

  imagenPerfilError = (event) => {
    event.target.src = GLOBAL.url + "no-photo-available.png";
  }

  // CLICK EN IMAGEN
  imageClick(event) {
    console.log("ir al plato");
  }

  obtenerDescripcionPlatoJSON = (cadena) => {
    //Devolvemos el valor del JSON que recibimos
    return cadena == null ? '' : JSON.parse(cadena)[0].data;
  }

  obtenerAlergenosPlatoJSON = (alergenos) => {
    alergenos = JSON.parse(alergenos);

    var colAlergenos: string[] = [];

    if (alergenos) {
      //Devolvemos los iconos de los alergenos del plato

      for (var aler of alergenos) {
        //Cogemos la etiqueta y el icono
        colAlergenos.push(aler.icon);
      };
    }

    return colAlergenos;
  }

  myFunction() {
    console.log("Pinta la función");
    var popup = document.getElementById("mypopup");
    popup.classList.toggle("show");
  }


  carouselOptions = {
    margin: 0,
    nav: true,
    navText: ["<div class='nav-btn prev-slide'></div>", "<div class='nav-btn next-slide'></div>"],
    responsiveClass: true,
    loop: false,
    responsive: {
      0: {
        items: 1,
        nav: true
      },
      600: {
        items: 3,
        nav: true
      },
      1000: {
        items: 4,
        nav: true
      },
      1500: {
        items: 5,
        nav: true
      }
    }
  }

  cambiarVistaSeccion(seccionId: any) {
    if (this.visibilidadSecciones[seccionId]) {
      this.visibilidadSecciones[seccionId] = false;
    } else {
      this.visibilidadSecciones[seccionId] = true;
    }
  }

  getCantidadCarrito(idProducto: number, precioId: number) {
    if(this.carrito!=null){
      if(this.carrito["fabricante-" + this.fabricante.id]!=null){
        let cantidad = 0;
        this.carrito["fabricante-" + this.fabricante.id].forEach(item => {
          if(item.productoId == idProducto && item.precioId == precioId){
            cantidad += item.cantidad;
          }
        });
        return cantidad;
      }
    }

    return 0;

  }

  goDetailProducto(slug: string) {
 
    let productoEncontrado = null;

    for (const seccion of this.fabricante.secciones) {
      const ps = seccion.productos_secciones.find(ps => ps.producto.slug === slug);
      if (ps) {
        productoEncontrado = ps.producto;
        break;
      }
    }

    if (productoEncontrado) {
      this.productoSeleccionado.emit(productoEncontrado);
    }
  }

  onIrCarrito() {
    this.router.navigate(['carrito']);
  }

  onClickModificarCantidad(idProducto: any, action: string) {

    this.fabricante.secciones.forEach(seccion => {
      (<any>seccion).fotoProductos.forEach(producto => {
        if (producto.idProducto == idProducto) {
          if (action == 'plus') {
            producto.cantidad++;
          } else {
            if (producto.cantidad > 0) {
              producto.cantidad--;
            }
          }

          this.modificarCantidadCarrito(producto.cantidad, producto.idProducto, producto.precioProducto.precioId);
        }
      });
    });
  }

  modificarCantidadCarrito(cantidad: number, idProducto: number, precioId: number){

    let model = {
      cantidad: cantidad,
      productoId: idProducto,
      precioId: precioId,
      nota: ""
    };

      this.carrito = JSON.parse(localStorage.getItem("carrito"));

      if(this.carrito==null){
        this.carrito = {};
      }

      if(this.carrito["fabricante-" + this.fabricante.id] == null){
        this.carrito["fabricante-" + this.fabricante.id] = [];
        this.carrito["fabricante-" + this.fabricante.id].push(model);
      } else {
        this.carrito["fabricante-" + this.fabricante.id] = this.carrito["fabricante-" + this.fabricante.id].filter(
          (item) => !(item.productoId == idProducto && item.precioId == precioId)
        );

        if(model.cantidad > 0){
          this.carrito["fabricante-" + this.fabricante.id].push(model);
        }else{
          if(this.carrito["fabricante-" + this.fabricante.id].length == 0){
            delete this.carrito["fabricante-" + this.fabricante.id];
            if (Object.keys(this.carrito).length === 0) {
              localStorage.setItem("carrito", null);
            }
          }
        }
      }

      localStorage.setItem("carrito", JSON.stringify(this.carrito));
      this.carritoActualizado.emit(this.tieneCarrito());
  }

  tieneCarrito(): boolean {
    if (this.carrito == null || this.carrito === undefined) {
      return false;
    }
    
    // Verifica que sea un objeto y tenga al menos una propiedad
    if (typeof this.carrito === 'object' && Object.keys(this.carrito).length > 0) {
      return true;
    }
    
    return false;
  }

}
